import React, { useCallback, useEffect, useRef, useState } from "react";
import Button from "../../framework/Button";
import SelectInput from "../../framework/SelectInput";
import { fetchBranches, fetchTerminals } from "../../services/branch-service";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Fade, IconButton, Tooltip } from "@mui/material";
import { generateOTP } from "../../services/otp-service";
import { getStringValue } from "../../utils/utils";
const GenerateOTP = () => {
  const [branches, setBranches] = useState([]);
  const [terminals, setTerminals] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedTerminal, setSelectedTerminal] = useState(null);
  const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);
  const [OTP, setOTP] = useState("");
  const [expiresIn, setExpiresIn] = useState("");
  const otpDivRef = useRef();
  const interval = useRef();
  const copyToClipboard = () => {
    navigator.clipboard.writeText(otpDivRef.current?.innerHTML);
    setShowCopiedTooltip(true);
    setTimeout(() => {
      setShowCopiedTooltip(false);
    }, 1000);
  };
  const fmtMSS = (s) => {
    return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
  };
  const clickHandler = useCallback(() => {
    generateOTP({
      retailer_id: selectedBranch?.code,
      terminal: selectedTerminal?.terminal_id,
    }).then((r) => {
      setExpiresIn(r.expire_in_seconds);
      if (interval.current) {
        clearInterval(interval.current);
      }
      interval.current = setInterval(() => {
        setExpiresIn((prev) => {
          if (prev - 1 === 0) clearInterval(interval.current);
          return prev - 1;
        });
      }, 1000);
      setOTP(r.otp?.split(" ")[0]);
    });
  }, [selectedBranch?.code, selectedTerminal?.terminal_id]);

  useEffect(() => {
    fetchBranches(`deleted=false`).then((r) => {
      const opts = r.result?.rows?.map((x) => {
        return {
          ...x,
          id: x._id,
          label: x.code,
        };
      });
      const sortedOpts = opts?.sort((x, y) => (x.region > y.region ? 1 : -1));
      setBranches(sortedOpts);
    });
  }, []);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        padding: "10px",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100px",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "15px",
          borderRadius: "5px",
          background: "rgba(0,0,0,.1)",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          padding: "10px",
        }}
      >
        <div style={{ width: "300px" }}>
          <SelectInput
            options={branches}
            label="Branch"
            required
            value={selectedBranch}
            onChange={(event, option) => {
              setSelectedBranch(option);
              fetchTerminals(`code=${option.code}`).then((response) => {
                if (response.status === "success") {
                  setTerminals(response.result);
                }
              });
            }}
            isOptionEqualToValue={(option, value) => {
              return option.id === value.id;
            }}
            getOptionLabel={(option) => `${option.label}`}
            groupBy={(option) => option.region}
            renderGroup={(params) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    padding: "5px",
                    gap: "5px",
                  }}
                  key={params.key}
                >
                  <div
                    style={{
                      height: "30px",
                      width: "100%",
                      background: "#e0e0e0",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px",
                      fontWeight: 700,
                    }}
                  >
                    {params.group}
                  </div>
                  <div>{params.children}</div>
                </div>
              );
            }}
            renderOption={(props, option, { selected }) => {
              return (
                <div
                  {...props}
                  style={{
                    display: "flex",
                    height: "40px",
                    width: "100%",
                    padding: "1px 5px",
                    gap: "5px",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItem: "center",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        height: "15px",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      {option.label}
                    </div>
                    <div
                      style={{
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {option.address}
                    </div>
                  </div>
                </div>
              );
            }}
          />
        </div>
        <div style={{ width: "300px" }}>
          <SelectInput
            options={terminals}
            label="Terminal"
            required
            disabled={!selectedBranch}
            value={selectedTerminal}
            onChange={(event, option) => {
              setSelectedTerminal(option);
            }}
            isOptionEqualToValue={(option, value) => {
              return option._id === value._id;
            }}
            getOptionLabel={(option) => option.terminal_id}
          />
        </div>
        <Button
          label="Generate OTP"
          color="violet"
          onClick={clickHandler}
          disabled={!selectedBranch}
        />
        <div
          style={{
            background: "#fff",
            borderRadius: "5px",
            width: "300px",
            height: "40px",
            fontSize: "30px",
            fontWeight: "700",
            letterSpacing: "5px",
            display: "flex",
          }}
        >
          <div
            ref={otpDivRef}
            style={{
              width: "calc(100% - 50px)",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItem: "center",
            }}
          >
            {OTP}
          </div>
          {OTP && (
            <span
              style={{
                width: "50px",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItem: "center",
                position: "relative",
              }}
            >
              <Tooltip
                key="copied"
                title={
                  <div
                    style={{
                      display: "flex",
                      gap: "2px",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    {showCopiedTooltip ? "Copied" : "Copy"}
                  </div>
                }
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 600 }}
              >
                <IconButton onClick={copyToClipboard}>
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>
            </span>
          )}
        </div>
        {getStringValue(expiresIn) && (
          <div>
            Expires In:{" "}
            <span style={{ fontWeight: 700, fontSize: "17px" }}>
              {expiresIn ? (
                fmtMSS(expiresIn)
              ) : (
                <span style={{ color: "red" }}>OTP has expired.</span>
              )}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default GenerateOTP;
